import React from 'react';
import { Link } from 'react-router-dom';

/** Inline service links: [[LINK:/path|anchor text]] → <Link> */
const LINK_TOKEN = /\[\[LINK:([^|]+)\|([^\]]+)\]\]/g;

/**
 * @param {string} text
 * @param {string} keyPrefix
 * @returns {React.ReactNode}
 */
export function renderRichParagraph(text, keyPrefix = '') {
  if (text == null || text === '') return null;
  if (typeof text !== 'string') return text;

  const parts = [];
  let last = 0;
  let match;
  const re = new RegExp(LINK_TOKEN.source, 'g');
  let linkIdx = 0;

  while ((match = re.exec(text)) !== null) {
    if (match.index > last) {
      parts.push(text.slice(last, match.index));
    }
    const to = match[1].trim();
    const label = match[2].trim();
    parts.push(
      React.createElement(
        Link,
        {
          key: `${keyPrefix}-lnk-${linkIdx++}`,
          to: to,
          className: 'inline-service-link'
        },
        label
      )
    );
    last = re.lastIndex;
  }

  if (last < text.length) {
    parts.push(text.slice(last));
  }

  if (parts.length === 0) return text;
  if (parts.length === 1 && typeof parts[0] === 'string') return parts[0];
  return React.createElement(React.Fragment, null, ...parts);
}
